import {format} from 'date-fns';
import {useMemo, useState} from 'react';

import {useGetDiscountCodesTrackingQuery} from '~/store/rtkQuery';

export const DiscountCodesTrackingModal = ({
  onCancel,
}: {
  onCancel: () => void;
}) => {
  const [fromDate, setFromDate] = useState(
    format(Date.now() - 30 * 24 * 60 * 60 * 1000, 'yyyy-MM-dd'),
  );
  const [toDate, setToDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const {data, isLoading, error} = useGetDiscountCodesTrackingQuery({
    fromDate,
    toDate,
  });

  const trackingData = useMemo(() => {
    if (data) {
      return Object.entries(data.discountCodes).map(([code, tracking]) => {
        return {
          code,
          subscriptions: tracking.subscriptions,
          subscriptionsSandbox: tracking.subscriptionsSandbox,
        };
      });
    }
    return [];
  }, [data]);

  return (
    <dialog className="modal modal-open">
      <div className="modal-box w-11/12 max-w-5xl">
        <div className="text-2xl">Discount Code Tracking</div>

        <div className="py-4">
          <div className="flex flex-row gap-8 mb-4">
            <div className="form-control">
              <label className="input input-bordered flex items-center gap-8">
                From Date
                <input
                  className="grow"
                  type="date"
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                />
              </label>
            </div>
            <div className="form-control">
              <label className="input input-bordered flex items-center gap-8">
                To Date
                <input
                  className="grow"
                  type="date"
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                />
              </label>
            </div>
          </div>

          {isLoading && (
            <span className="loading loading-dots loading-md"></span>
          )}

          {trackingData.length === 0 && !isLoading && !error && (
            <div className="alert alert-info">
              No discount code attributions found for selected dates.
            </div>
          )}

          {trackingData.length > 0 && (
            <table className="table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Subscriptions</th>
                  <th>Subscriptions Sandbox</th>
                </tr>
              </thead>

              <tbody>
                {trackingData.map(code => {
                  return (
                    <tr key={code.code}>
                      <td>{code.code}</td>
                      <td>{code.subscriptions}</td>
                      <td>{code.subscriptionsSandbox}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {!!error && (
          <div role="alert" className="alert alert-error">
            <span>{error.message}</span>
          </div>
        )}

        <div className="modal-action">
          <button className="btn" onClick={onCancel}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
};
